import React, { Component } from 'react';
import './home.css';
import appstoreBadge from './img/btn-apple-download.svg';
import Apps from '../apps/apps.js';
import Scrollchor from 'react-scrollchor';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faArrow from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faArrowUp from '@fortawesome/fontawesome-free-solid/faAngleUp';
import AboutUs from '../about-us/about-us.js';

class Home extends Component {

  render() {

    return (
        <div id="top">
            <div className="container-fluid first-section text-center text-white font-weight-light section noPadding">
                <div className="container-fluid section-header mx-auto">
                    <h1><span>Igrecway</span></h1>
                    <p className="lead">We create amazing iPhone and iPad applications.</p>
                    <a href="https://apps.apple.com/us/developer/nataliya-smirnova/id539362207"><img src={appstoreBadge} alt="Appstore"/></a>
                    
                </div>
                <div className="container-fluid section-navigation">
                    <Scrollchor to="#apps" className="text-white"><FontAwesomeIcon icon={faArrow} /></Scrollchor>
                </div>
            </div>
            <div className="container-fluid second-section pb-4 noPadding" id="apps">
                <div className="container-fluid section-navigation-up">
                    <Scrollchor to="#top" className="text-dark"><FontAwesomeIcon icon={faArrowUp} /></Scrollchor>
                </div>
                <div className="container-fluid section-header pt-5">
                    <h1 className="iw-color-2 mb-4">Apps</h1>
                    <Apps />
                </div>
                <div className="container-fluid section-navigation-up">
                    <Scrollchor to="#about" className="text-dark"><FontAwesomeIcon icon={faArrow} /></Scrollchor>
                </div>
            </div>
            <div className="container-fluid third-section pb-3 noPadding" id="about">
                <div className="container-fluid section-navigation-up">
                    <Scrollchor to="#apps" className="text-white"><FontAwesomeIcon icon={faArrowUp} /></Scrollchor>
                </div>
                <div className="container-fluid section-header pt-5">
                    <AboutUs />
                </div>
            </div>
        </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home/Home.js